import { render, staticRenderFns } from "./PopUpMenu.vue?vue&type=template&id=039643bc&"
import script from "./PopUpMenu.vue?vue&type=script&lang=js&"
export * from "./PopUpMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports